import BtnProgress from './component/BtnProgress';
import BtnCheck from './component/BtnCheck';
import Animation from './component/Animation';
import { Form } from './component/Form';
import FlashMessage from './component/FlashMessage';
import ToggleShow from './component/ToggleShow';
import Navbar from './component/Navbar';
import NetteForms from 'nette-forms';

document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));
NetteForms.initOnLoad();
(<any>window).nette = NetteForms;

window.addEventListener('DOMContentLoaded', () => {
    BtnProgress.init();
    BtnCheck.init();
    Animation.init();
    Form.init();
    FlashMessage.init();
    ToggleShow.init();
    Navbar.init();
});

window.addEventListener('scroll', () => {
    Animation.init();
});
